<template>
  <div class="project-item-root">
    <div class="project-item-img-wrapper">
      <img :src="info.images[0]" />
      <div class="project-item-img-hover" @click="openModal"></div>
    </div>
    <div class="project-item-header">
      <h4>{{ info.name }}</h4>
      <p>{{ info.subName }}</p>
    </div>
    <div v-if="isOpenModal" class="project-modal" @click="closeModal">
      <div class="project-modal-content">
        <div class="project-modal-bar">
          <div class="project-modal-bar-btn" @click="closeModal">
            <fa-icon icon="times" />
          </div>
        </div>
        <div class="project-modal-header">
          <h2>{{ info.name }}</h2>
          <p>{{ info.subName }}</p>
          <div class="header_details">
            <a :href="info.detailLink" target="_blank" @click="onClickLink">{{
              info.detailLinkText
            }}</a>
            <p>{{ info.period }}</p>
            <a :href="info.link" target="_blank" @click="onClickLink">{{
              info.linkText
            }}</a>
          </div>
        </div>
        <div class="project-modal-scroll-content">
          <div class="project-modal-img-wrapper">
            <img :src="info.images[0]" />
          </div>
          <p class="project-modal-description">
            {{ info.description }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      isOpenModal: false,
    };
  },
  props: {
    info: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  methods: {
    closeModal(e) {
      e.preventDefault();
      this.isOpenModal = false;
      document.body.style.overflow = 'unset';
    },
    openModal(e) {
      e.preventDefault();
      this.isOpenModal = true;
      document.body.style.overflow = 'hidden';
    },
    onClickLink(e) {
      e.stopPropagation();
    },
  },
};
</script>

<style>
.project-item-root {
  background-color: #a6978fdd;
  overflow: hidden;
}

.project-item-img-wrapper {
  background-color: #21212188;
  width: 100%;
  position: relative;
  padding-top: 75%;
  overflow: hidden;
}

.project-item-img-hover {
  position: absolute;
  top: 0%;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
}

.project-item-img-hover:hover {
  background-color: #ffffff33;
}

.project-item-img-wrapper img {
  position: absolute;
  top: 0%;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.project-item-header {
  margin: 0px 20px;
}

.project-item-header h4 {
  margin-top: 20px;
}

.project-item-header h4,
.project-item-header p {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.project-modal {
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  z-index: 2000;
  background-color: rgba(0, 0, 0, 0.2);
  padding: 30px;
  align-items: center;
  justify-content: center;
}

.project-modal-content {
  flex: 1 1 auto;
  height: 100%;
  max-width: 800px;
  background-color: white;
  border-radius: 5px;
  box-shadow: 0px 4px 10px 5px rgba(0, 0, 0, 0.15);
  word-break: break-all;
  display: flex;
  flex-direction: column;
  padding: 5px;
  overflow: hidden;
}

.project-modal-bar {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.project-modal-bar-btn {
  margin-right: 5px;
  cursor: pointer;
}

.project-modal-header {
  margin: 0px 20px;
  flex: 0 0 auto;
}

.project-modal-header h2,
.project-modal-header p {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.header_details {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
}

.header_details p,
.header_details a {
  font-size: 14px;
  flex: 1 1 1px;
  color: #212121;
}

.header_details a {
  font-weight: bold;
}

.header_details a:hover {
  transform: scale(1.05);
  color: #212121;
}

.project-modal-img-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
}

.project-modal-img-wrapper img {
  width: 80%;
  height: auto;
  object-fit: contain;
}

.project-modal p {
  padding: 0;
  margin: 0;
}

.project-modal-scroll-content {
  margin: 10px auto 0px auto;
  text-align: left;
  overflow-y: scroll;
}

.project-modal-description {
  font-size: 15px;
  margin: 20px !important;
  word-wrap: break-word;
  word-break: keep-all;
  white-space: pre-wrap;
}
</style>
